import { useSendBlockModal } from '@/contexts/SendBlockModalContext';
import { ViewOnlyBlockModal } from './ViewOnlyBlockModal';

export function GlobalViewOnlyBlockModal() {
  const { viewOnlyBlockOpen, closeViewOnlyBlockModal } = useSendBlockModal();

  return (
    <ViewOnlyBlockModal
      open={viewOnlyBlockOpen}
      onOpenChange={(open) => {
        if (!open) closeViewOnlyBlockModal();
      }}
    />
  );
}
